export const userKeys = {
  all: ["users"] as const,
  recruiters: ["users", "recruiters"] as const,
  item: (userId: string) => [...userKeys.all, "item", userId],
};
